import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCStefan extends NPC {
    constructor() {
        super(definitions.NPC_ID.STEFAN);

        this.collisionRadius = 34;
        this.collisionOffsetX = -14;
        this.collisionOffsetY = -30;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_stefan_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(8, -12));
        this.animateIdle(0.6);
    }
}